module.exports = __webpack_public_path__ + "img/06.70fc000d.png";